module.exports = __webpack_public_path__ + "img/icon-slide4.26492f13.jpg";